module.exports = __webpack_public_path__ + "img/44.4b1c91e0.png";